import { render } from "./editor.vue?vue&type=template&id=4a98de46&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=4a98de46&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a98de46"]])

export default __exports__